import {GroupsListFilter} from "../libs/filters/groupsListFilter";
import FilterButtonDataSource from "../libs/filters/DataSource";

const openDrawer = function (text) {
    $('.mobile-drawer').remove()
    const drawer = $(`
<div id="FiltersDrawer" class="mobile-drawer" role="alertdialog" style="display: none">
        <div class="header">
            <a href="#" class="clear-all">${translate.clear_all}</a>
            <h2>${translate.filters}</h2>
            <button type="button" class="close" aria-label="${translate.close_btn}"><span><svg viewBox="0 0 27 27"><title>${translate.close_btn}</title><use xlink:href="#icon-close-small"></use></svg></span></button>
        </div>
        ${text}
        <div class="footer">
            <button type="button" class="apply">${translate.apply_filters}</button>
        </div>
</div>`)

    drawer.appendTo('body')

    const globalListener = e => { if(!drawer[0].contains(e.target)) drawer.remove()};
    setTimeout(() => window.addEventListener('click', globalListener), 0)
    drawer.on('removed', e => removeEventListener('click', globalListener))

    drawer.find('button.close').on('click', function () {
        $(this).closest('#FiltersDrawer').remove();
        return false
    })
    drawer.find('li a').on('click', function () {
        $(this).parent().toggleClass('selected')
        $(this).attr('aria-checked', $(this).parent().hasClass('selected') ? 'true' : 'false')
        return false
    })
    drawer.find('.clear-all').on('click', function () {
        drawer.find('li.selected').removeClass('selected').find('a').attr('aria-checked', 'false')
        return false
    })
    drawer.slideDown()
    return drawer
}

const getSwitches = function ($container) {
    const result = []
    const methods = {
        AND: 'filter',
        OR: 'merge',
    }
    $container.find('li[data-name]').each(function () {
        result.push({
            name: $(this).data('name'),
            method: methods[$(this).data('method')] || 'filter',
            tags: $(this).find('li.selected a').map(function () {
                return $(this).text()
            }).get(),
        })
    })
    return result
}

const setSwitches = function ($container, enabled = []) {
    enabled.forEach(function (item) {
        $container.find(`[data-name="${item.name}"] li`).map(function () {
            if (item.tags.includes($(this).find('a').text())) {
                $(this).addClass('selected')
                $(this).find('a').attr('aria-checked', 'true')
            }
        })
    })
}

/**
 * @param list Array
 * @returns String
 */
const buildTagsList = function (list) {
    const tags = list.map(item => {
        item = item.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;')
        return `<li><a href="#" role="checkbox">${item}</a></li>`
    })
        .join('')
    return `<menu>${tags}</menu>`
}

const buildSection = function (section) {
    if (section.tags || []) {
        return `<li data-name="${section.name}" data-method="${section.method}"><label>${section.name}</label>${buildTagsList(section.tags)}</li>`
    }
}

export default context => {
    const button = $('#ShowFilters', context)
    if (button.length && button.data('config')) {
        button.on('click', function () {
            const drawer = openDrawer('<menu>' + $(this).data('config').map(item => buildSection(item)).join('') + '</menu>')
                .find('button.apply').on('click', function () {
                    button.data('enabled', getSwitches(drawer) || [])
                    button.toggleClass('active', button.data('enabled'))
                    drawer.remove()
                    filterSource.trigger('update')
                    return false
                }).prevObject
            setSwitches(drawer, button.data('enabled'))

        })
    }
    const filterSource = new FilterButtonDataSource(button, 'enabled')
    $('[id^="panel__"]', context).each(function () {
        const filter = $(this).data('filter')
        if (filter instanceof GroupsListFilter) {
            filter.addSource(filterSource)
        }
    })
}
